import React, { useState, useEffect, useContext } from "react";
import Dropdown from "core/ui/Dropdown";
import SessionContext from "SessionContext";
import { ValidateCost, HandleCostPaste, HandleCostKey } from "./royalty-partials/royalty-helpers";
import { Input, Label, Form, FormGroup, Col, InputGroup, InputGroupText, Button } from "reactstrap"
import isEqual from "lodash.isequal";

function CreateChannelDetails(props) {
  const { select, index, channelHasChanges, remove = null } = props;
  const session = useContext(SessionContext);

  const channel_init = {
    indexValue: index,
    channelName: "",
    channel_option_id: null,
    effective_date: null,
    cost_per_record: 0,
  };

  const [channelOptionList, setChannelOptionList] = useState(null);
  const [channelCost, setChannelCost] = useState("");
  const [channelDetails, setChannelDetails] = useState({...channel_init});
  const [disableSaveBtn, setDisableSaveBtn] = useState(true);
  const [savedData, setSavedData] = useState({});
  const [saveBtnLabel, setSaveBtnLabel] = useState("Save Channel");
 
  useEffect(() => { 
    setChannelDetails({
      ...channelDetails,
      cost_per_record: Number(channelCost),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelCost]);

  useEffect(() => {
    loadChannelOptionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function loadChannelOptionList() {
    session
      .query("admin/get_channel_options")
      .then((response) => {
        setChannelOptionList(response);
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
      });
  }

  const handleUpdate = () => {
    select(channelDetails);
    setSavedData(channelDetails);
  };

  const handleChannel = (value) => {
    setChannelDetails({
      ...channelDetails,
      channel_option_id: value.id,
      channelName: value.name,
    });
  };

  const handleDate = (value) => {
    let formattedDate = value.replace(/-/g, "");
    setChannelDetails({
      ...channelDetails,
      effective_date: formattedDate,
    });
  };

  const handleCost = (event) => {
    const value = event.target.value;
    const validated = ValidateCost(value);

    if (validated) {
      setChannelCost(value);
    } else {
      event.target.value = channelCost || "";
    }
  };

  useEffect(() => {
    // check if ready to save
    if (
      channelDetails.channel_option_id === null ||
      channelDetails.effective_date === null ||
      channelDetails.cost_per_record === 0
    ) {
      setDisableSaveBtn(true);
    } else {
      setDisableSaveBtn(false);
    }

    if(isEqual(channelDetails, savedData)) {
      // check if already saved
      setDisableSaveBtn(true);
      setSaveBtnLabel("Update Channel");
      channelHasChanges(false);
    } else if(isEqual(channel_init, channelDetails)) {
      channelHasChanges(false);
    } else {
      channelHasChanges(true);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelDetails, savedData])

  return (
    <div className="channel-details">
      <div>
        <div className="channel-remove">
          <span>Channel: <strong>{channelDetails.channelName}</strong></span>
          {remove !== null ? (
            <i className="bi bi-trash3" onClick={() => remove(index)}></i>
          ) : (
            ""
          )}
        </div>
        <Dropdown
          label="Select Channel"
          options={channelOptionList}
          select={handleChannel}
          remove={false}
        />
      </div>
      <div className="right-aligned">
         <Form>
          <FormGroup row>
            <Label
              for="royalty-cost"
              sm={6}>
              Price:
            </Label>
            <Col sm={6}>
            <InputGroup>
              <InputGroupText>
                <i className="bi bi-currency-dollar"></i>
              </InputGroupText>
                <Input
                  id="royalty-cost"
                  type="text"
                  value={channelCost}
                  onChange={(e) => handleCost(e)}
                  onKeyDown={(e) => HandleCostKey(e)}
                  onPaste={(e) => HandleCostPaste(e)}
                />
            </InputGroup>
          </Col>
          </FormGroup>
          <FormGroup row>
            <Label
              sm={6}
            >
              Select a New Date:{" "}
            </Label>
            <Col sm={6}>
              <InputGroup>
                <InputGroupText><i className="bi bi-calendar-check"></i></InputGroupText>
              <Input
                type="date"
                onChange={(e) => handleDate(e.target.value)}
                />
              </InputGroup>
            </Col>

          </FormGroup>
        <FormGroup>
          <br />
          <Button className="promote" type="button" onClick={handleUpdate} disabled={disableSaveBtn}>
            {saveBtnLabel}
          </Button>
        </FormGroup>
        </Form>
      </div>
    </div>
  );
}

export default CreateChannelDetails;
